module.exports = __webpack_public_path__ + "static/media/location.36d673d4.svg";